import React, { useContext, useEffect } from "react";
import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";
import { useNavigate } from "react-router-dom";
import HeaderEmpleado from "../gestionEmpleados/HeaderEmpleado";

function DashboardEmpleado() {
  const { empleado } = useContext(AuthEmpleadoContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!empleado) navigate("/loginEmpleados");
  }, [empleado, navigate]);

  if (!empleado) return null;

  return (
    <>
      <HeaderEmpleado />

      <div className="container py-5">

        {/* TITULO */}
        <div className="text-center mb-5">
          <h2 className="fw-bold text-white">Panel del Docente</h2>
          <p className="text-light opacity-75">
            Bienvenido/a {empleado.nombre}
          </p>
        </div>

        <div className="row justify-content-center g-4">

          {/* PERFIL */}
          <div className="col-lg-4 col-md-6">
            <div className="card shadow-lg border-0 rounded-4 h-100 text-center">

              <div className="card-body p-4">

                <div
                  className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center mx-auto mb-3 shadow"
                  style={{ width: 90, height: 90, fontSize: 32 }}
                >
                  👤
                </div>

                <h5 className="fw-bold">
                  {empleado.nombre} {empleado.apellido}
                </h5>

                <span className="badge bg-secondary mb-3">
                  {empleado.rol}
                </span>

                <div className="text-start mt-3 small">
                  <p className="mb-1">
                    <strong>CUIT:</strong> {empleado.cuit}
                  </p>
                  <p className="mb-0">
                    <strong>Email:</strong> {empleado.mail}
                  </p>
                </div>

              </div>
            </div>
          </div>

          {/* ACCIONES */}
          <div className="col-lg-6 col-md-6">
            <div className="row g-4">

              {/* MIS RECIBOS */}
              <div className="col-12">
                <div
                  className="card shadow-lg border-0 rounded-4 h-100 hover-card"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/misRecibos")}
                >
                  <div className="card-body p-4 d-flex align-items-center justify-content-between">

                    <div>
                      <h5 className="fw-bold mb-2">
                        📄 Mis Recibos
                      </h5>
                      <p className="text-muted mb-0">
                        Consultá y descargá tus recibos de sueldo.
                      </p>
                    </div>

                    <div className="fs-1 text-success">
                      →
                    </div>

                  </div>
                </div>
              </div>

              {/* PERFIL */}
              <div className="col-12">
                <div className="card shadow-lg border-0 rounded-4 h-100">
                  <div className="card-body p-4 d-flex align-items-center justify-content-between">

                    <div>
                      <h5 className="fw-bold mb-2">
                        👁 Perfil
                      </h5>
                      <p className="text-muted mb-2">
                        Ver y consultar tus datos personales.
                      </p>

                      <button
                        className="btn btn-outline-success btn-sm rounded-pill"
                        onClick={() => navigate("")}
                      >
                        Ver perfil
                      </button>
                    </div>
                    <div className="fs-1 text-success">
                      ⚙
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default DashboardEmpleado;
